<template>
  <f7-page no-toolbar no-swipeback name="financial" class="page-center" >
    <f7-navbar innerClass="navbar-inner">
      <f7-nav-left>
        <f7-link @click="$f7router.back()">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("myPosition_0002") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div v-html="descContent || '- -'"></div>
  </f7-page>
</template>

<script>
import { getCookie } from "@/config/utils";
import { getreferrerlevelupgradecopywritingbymemberget } from "../../../axios/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      lang:'',
      descContent:'' ,
    };
  },
  watch: {},
  computed: {},
  methods: {
    
  },
  created() { 
    this.lang = getCookie('lang');
    if(this.lang=='' || this.lang==null  || this.lang==undefined){
      this.lang = 'esES';
    }
    getreferrerlevelupgradecopywritingbymemberget().then((data) => {
      if (data.Code === "NoError") {
        this.descContent = data.Data.DescContent;
      }
    });
  },
  mounted() { 
    
  },
};
</script>
<style lang="less" scoped>
::v-deep .navbar-inner{    //头部颜色更换
  color: white;
  background: linear-gradient(1.98deg, #0887b2 3.12%, var(--f7-THEME-color) 95.71%);
  a{
    color: white;
  }
}
::v-deep .page-content::after{
  height: 0px;
}
</style>